import {
  createBrowserRouter,
  createRoutesFromElements,
  Routes,
  Route,
} from "react-router-dom";
import App from "../App";
import Home from "../pages/home";
import BlogPage from "../pages/Blog/AllBlogs";
import AboutPage from "../pages/About/About";
import ContactPage from "../pages/Contact/Contact";
import TermsConditions from "../pages/terms-and-conditions/TermsConditions";
import PrivacyPolicy from "../pages/privacy-policy/PrivacyPolicy";
import { SingleBlog } from "../pages/Blog/SingleBlog";

export const route = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "blog",
        element: <BlogPage />,
      },
      {
        path: "blog/:id",
        element: <SingleBlog />,
      },
      {
        path: "about-us",
        element: <AboutPage />,
      },
      {
        path: "contact",
        element: <ContactPage />,
      },
      {
        path: "terms",
        element: <TermsConditions />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
    ],
  },
]);
